export const VALID_AVATAR_EXTENSIONS = ['.png', '.jpg', '.jpeg'];
export function isValidAvatarImageType(imageUrl) {
  if (!imageUrl) {
    return true;
  }
  const fileExtension = imageUrl.toLowerCase().slice(imageUrl.lastIndexOf('.'));
  return VALID_AVATAR_EXTENSIONS.includes(fileExtension);
}